import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import BannerComponent from './js/banner.component';
import Banner from './js/banner';

ComponentsFactory.getInstance().define('banner', BannerComponent);

export {
    Banner
};
